import {
ApptReasonCode
} from 'one-state-apptreasoncode/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Cancel Appointment Component
 * @param response has the backend
 * Cancel Appointment Reason codes response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
     let result :any = {
        getreasoncodeinfo:[],
        error:undefined
    }

    const { log } = context;
    let responsearray:any = [];
    // TODO:verify backend team check for errors
    if (response && response.status >= 400) {
        result.error=response;
     }
    // TODO:verify backend team check for errors
    if (response?.length > 0) {
      response.forEach((dataresponse:any)=>{
          if(dataresponse) {
            dataresponse?.appointmentcancelreasons.forEach((apptreason:any)=>{
                let data:ApptReasonCode = {
                    reason: "",
                    reasoncode: ""
                }
                  if(apptreason) {
                      data.reason = apptreason?.name
                      data.reasoncode = apptreason?.appointmentcancelreasonid
        
                  }
                  responsearray.push(data);
              })
                result.getreasoncodeinfo=responsearray;
          }
      })

    }
    log.debug(
        "ccw-gadget,getapptreasocode-athena",
        "getapptreasocode-athena transformation response ", {
        result
    });
    return result;
}